import React from 'react'
import Todo from './Todo'

const TodoList = ({todos,handleComplete}) => {
  return (
    <div className='todo-list'>
        {
            todos?.map((todo,index) =>{

                return <Todo key={todo.id} todo ={todo} handleComplete={handleComplete}/>

            })
        }

    </div>
  )
}

export default TodoList